import { render, staticRenderFns } from "./MainContractsList.vue?vue&type=template&id=7c648bca&scoped=true"
import script from "./MainContractsList.vue?vue&type=script&lang=js"
export * from "./MainContractsList.vue?vue&type=script&lang=js"
import style0 from "./MainContractsList.vue?vue&type=style&index=0&id=7c648bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c648bca",
  null
  
)

export default component.exports